module.exports = __webpack_public_path__ + "img/icon-water-advanture.308d57fd.png";